export default "__VITE_ASSET__D7xo8ly9__"